export enum RecordingTypesEnum {
  SELECT = "select",
  RECORD = "record",
  UPLOAD = "upload"
}
